module.exports = __webpack_public_path__ + "assets/img/footer_fukidashi_sp.c400ce5c.svg";